module.exports = __webpack_public_path__ + "img/image-mars.1e869458.webp";